import Vue from "vue";
import firebase from 'firebase/compat/app'

export default {
};

export const functions = {
  install(Vue) {
    Vue.prototype.$functions = {
      call: async function (name, data) {
        var result = '';
        try {
          var callable = firebase.functions().httpsCallable(name);
          result = await callable(data);
        }
        catch (e) {
          console.log(e);
        }
        return result;
      },
    }
  }
};

Vue.use(functions);